import React, { Component } from 'react';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker,Checkbox } from 'antd';

import './profile.css';
import Skeleton from 'react-loading-skeleton';
const Panel = Collapse.Panel;
const { TextArea } = Input;


class EducationalInfo extends Component {

    state = {
        // value: "type here!",
        isInEditMode: false
    }

    changeEditMode = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode
        })
    }

    updateComponentValue = () => {
        this.setState({
            isInEditMode: false,
            // value: this.refs.theTextInput.value
        })
    }

    renderEditView = () => {
        const Option = Select.Option;
        const FormItem = Form.Item;

        return (<div className='container'>
            <Collapse defaultActiveKey={['1']} accordion bordered={false} >
                <Panel key="1" header={<div> <span className="myProfile-collapse-header"> Educational Information </span> <span style={{ fontSize: '12px', color: 'grey', fontWeight: 300, marginLeft: '14px' }}>Edting...</span> </div>}>
                    <Form className='myprofile-form' style={{display:'block'}}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="High School Name"
                                    >
                                        <Input placeholder="High School Name" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="High School City"
                                    >
                                        <Input placeholder="High School City" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Higher Education School Name 1"
                                    >
                                        <Input placeholder="Higher Education School Name 1" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Degree / Certificate / Degree / Certificate 1"
                                    >
                                        <Input placeholder="Degree / Certificate / Degree / Certificate 1" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="ClassYear1 / Class Year 1"
                                    >
                                        <Input placeholder="ClassYear1 / Class Year 1" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="FieldOfStudy 1"
                                    >
                                        <Input placeholder="FieldOfStudy 1" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Higher Education School Name 2"
                                    >
                                        <Input placeholder="Higher Education School Name 2" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Degree2 / Certificate / Degree / Certificate 2"
                                    >
                                        <Input placeholder="Degree2 / Certificate / Degree / Certificate 2" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="ClassYear2 / Class Year 2"
                                    >
                                        <Input placeholder="ClassYear2 / Class Year 2" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="FieldOfStudy 2"
                                    >
                                        <Input placeholder="FieldOfStudy 2" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Higher Education School Name 3"
                                    >
                                        <Input placeholder="Higher Education School Name 3" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Degree3 / Certificate / Degree / Certificate 3"
                                    >
                                        <Input placeholder="Degree3 / Certificate / Degree / Certificate 3"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="ClassYear3 / Class Year 3"
                                    >
                                        <Input placeholder="ClassYear3 / Class Year 3" 
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="FieldOfStudy 3"
                                    >
                                        <Input placeholder="FieldOfStudy 3"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Education Other Information"
                                    >
                                        <TextArea placeholder="Education Other Information" autosize={{ minRows: 2, maxRows: 10 }} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <hr className="line-divider-full" />
                                <Row type='flex' justify='space-around'>
                                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                    <Row type='flex' justify='space-around'>
                                    <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                        <Button className="myprofile-cancel-btn" onClick={this.changeEditMode}>Cancel</Button>
                                    </Col>
                                   <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                        <Button className="save-change-btn" onClick={this.updateComponentValue} type="primary">SAVE CHANGE</Button>
                                    </Col>
                                    </Row>
                                </Col>
                                </Row>
                        </p>
                    </Form>
                </Panel>
            </Collapse>
        </div>

        )
    }

    renderDefaultView = () => {
        return (
            <div className='container'>
                <Collapse bordered={false} >
                    <Panel header={<div className="alumni-header"> <span className="myProfile-collapse-header"> Educational Information </span>
                        <span className="editing-btn"><i class="fa fa-pencil" onClick={this.changeEditMode}></i></span>
                    </div>}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>High School Name</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>High School City</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Higher Education School Name 1</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Degree/Certificate/ Degree/Certificate 1</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>ClassYear1/ Class Year 1</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>FieldOfStudy 1</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Higher Education School Name 2</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Degree2/Certificate/ Degree/Certificate 2</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>ClassYear2/ Class Year 2</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>FieldOfStudy 2</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Higher Education School Name 3</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Degree3/Certificate/ Degree/Certificate 3</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>ClassYear3/ Class Year 3</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>FieldOfStudy 3</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Education Other Information</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                            </Row>
                        </p>
                    </Panel>
                </Collapse>
            </div>
        )
    }


    render() {

        return this.state.isInEditMode ?
            this.renderEditView() :
            this.renderDefaultView()
    }
}

export default EducationalInfo;


// WEBPACK FOOTER //
// ./src/components/AlumniProfile/EducationalInfo.js